import { jsx as _jsx, jsxs as _jsxs } from 'react/jsx-runtime.js';
import { Base, Flex, Heading } from '@stepstone-genesis/components';
import { Trans, useTranslation } from '@stepstone-platform/i18n';
import { BrandLogo } from './BrandLogo.js';
import { useMobile } from '../../../../helpers/hooks/index.js';
export const LoggedInContent = () => {
    const { t } = useTranslation();
    const isMobile = useMobile();
    const headingLabel = isMobile
        ? t('loginregistration.fullscreenModalContent.loggedIn.mobileHeader')
        : t('loginregistration.fullscreenModalContent.loggedIn.header');
    return (_jsxs(Flex, { flxDirection: 'column', pb: ['spaceNone', 'spaceXl'], children: [isMobile ? _jsx(BrandLogo, {}) : null, _jsxs(Flex, { flxDirection: 'column', gap: ['spaceM', 'spaceL', 'spaceXl'], pt: ['spaceXxl', 'spaceXl'], pb: 'spaceM', children: [_jsx(Heading, { as: "h1", variant: 'hero', children: headingLabel }), _jsx(Heading, { as: "h2", variant: 'title', children: _jsx(Trans, { i18nKey: 'loginregistration.fullscreenModalContent.loggedIn.underHeader', components: [
                                _jsx(Base, { as: 'span', sx: { color: 'colorActionableDefault' } }, 0),
                                _jsx("br", {}, 1),
                            ] }) })] })] }));
};
//# sourceMappingURL=LoggedInContent.js.map